var _style, _path, _path2, _path3, _path4, _line, _line2, _line3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStorageCanister(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-4 -5 8 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlLang: "en",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .can-stroke {\n      stroke: inherit;\n      fill: transparent;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "can-stroke",
    strokeWidth: 0.7,
    d: "M-3 -4 h6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "can-stroke",
    strokeWidth: 0.3,
    d: "       M-2 -3       l-1 4       v5       h6       v-5       l-1 -4       z     "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "can-stroke",
    strokeWidth: 0.1,
    d: "M-3 1 h6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "can-stroke",
    strokeWidth: 0.3,
    d: "       M-2.4 6       v1       h4.8       v-1     "
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "can-stroke",
    strokeWidth: 0.2,
    x1: -3,
    y1: -4,
    x2: -2,
    y2: -3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "can-stroke",
    strokeWidth: 0.2,
    x1: 3,
    y1: -4,
    x2: 2,
    y2: -3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "can-stroke",
    strokeWidth: 0.2,
    x1: 0,
    y1: -4,
    x2: 0,
    y2: -3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorageCanister);
export default __webpack_public_path__ + "static/media/storage-canister.dc2e75080d319082a8149f3e98e1ae21.svg";
export { ForwardRef as ReactComponent };